<template>
  <div
    v-if="isVisible"
    class="scroll-to-top"
    @click="scrollToTop()"
  >
    <img
      src="/static/images/icon-top.svg"
      alt="icone-ir-para-o-top"
    >
  </div>
</template>

<script>
export default {
  name: 'PageScrollTop',
  data: () => ({
    isVisible: false
  }),
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    handleScroll () {
      if (window.pageYOffset > 125) {
        this.isVisible = true
      } else {
        this.isVisible = false
      }
    }
  }
}
</script>

<style lang="scss">
  .scroll-to-top {
    background-color: #7F1A54;
    border-radius: 100%;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: 50px;
    bottom: 50px;
    cursor: pointer;
    z-index: 1;
    box-shadow: 0px 3px 6px rgba(0,0,0,0.16);
    &:hover {
      opacity: 0.9;
    }
  }
</style>
